export default __webpack_public_path__ + "static/media/2408245.1e992990.webp";